import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { useEffect, useState } from "react";
import { Route, Switch } from "react-router";
import PortalContainer from "../../_+_Portal";
import GlobalProvider from "../context/Provider";

const RouterApp = () => {
  const [jsonLeido, setJsonLeido] = useState(false);

  useEffect(() => {
    fetch(`./config.json?v=${new Date().getTime()}`)
      .then((response) => {
        return response.json();
      })
      .then((jsondata) => {
        localStorage.setItem("config", JSON.stringify(jsondata));
        setJsonLeido(true);
      });
  }, []);

  return (
    <>
      {jsonLeido && (
        <>
          <GlobalProvider>
            <IonReactRouter>
              <IonRouterOutlet>
                <Switch>
                  <Route path={"/"} component={PortalContainer} />
                </Switch>
              </IonRouterOutlet>
            </IonReactRouter>
          </GlobalProvider>
        </>
      )}
    </>
  );
};

export default RouterApp;
